import { useParams, useSearchParams } from "react-router-dom";
import DocumentOrchestrator from "../editors/composer/DocumentOrchestrator";

export default function LexicalEditorPage() {
  const { docId = "" } = useParams();
  const [searchParams] = useSearchParams();
  
  // Extract versionId from query parameters (e.g., ?versionId=v1.0)
  const versionId = searchParams.get('versionId') || undefined;
  
  console.log(`🎯 [LexicalEditorPage] Extracted IDs:`, {
    docId,
    versionId: versionId || 'active (default)',
    timestamp: new Date().toISOString()
  });

  // Force the orchestrator to mount the Lexical editor implementation.
  // It will still bootstrap shared services (document, fonts, collab, layout)
  // and pass getDeviceScale() for render-only DPI scaling.
  return <DocumentOrchestrator docId={docId} versionId={versionId} preferredEditor="lexical" />;
}
